<template>
  <b-row class="place-row">
    <b-col md="8" sm="12">
      <b-row>
        <b-col sm>
          <div class="p-address1 w-100">
            {{ store.address.street }} {{ store.address.street2 }}
          </div>
          <div class="p-address2 w-100">
            {{ store.address.city }}, {{ store.address.region }}
            {{ store.address.postalCode }}
          </div>
          <div class="p-contact c-blue c-pointer w-100">
            <a :href="'tel:'+store.mainPhone" class="phone-click-link">{{ store.mainPhone }}</a>
          </div>
        </b-col>
        <b-col sm class="hours-information">
          <div class="text-bold p-time c-green w-100">
            Open Until {{ store.currentHours }}
          </div>
          <div class="p-distance md-b15 w-100">
            {{ store.distance.distanceMiles.toFixed(1) }} Miles
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col md="4" sm="12" class="d-flex">
      <slot name="right-column">
        <button
          class="btn select-store-btn w-100"
          @click.stop="setStore(store['location-id'])"
          v-if="!isActive"
        >
          Select This Store
        </button>
        <button
          class="btn select-store-btn w-100 active"
          @click.stop="setStore(store['location-id'])"
          v-else
        >
          Selected Store
        </button>
      </slot>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "SingleStoreResultCompactVariant",
  props: {
    store: Object,
    item_index: Number,
    locationSearchView: {
      type: Boolean,
      default: false,
    },
    isMyStore: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      selectedStore: null,
    };
  },
  computed: {
    isActive() {
      if (this.activeFormStore === this.item_index) {
        return true;
      }
      return false;
    },
    activeFormStore() {
      if (this.$store.state.user.selectedResultIndex !== null) {
        return this.$store.state.user.selectedResultIndex;
      }
      return false;
    },
  },
  methods: {
    // @TODO - Refactor the methods into an 'interface' module/component/composable to allow for reuse of the standard functions
    setStore() {
      //@TODO - Make sure this works correctly and/or abstract the functionality and let the parent component handle this
      // Currently we are forcing it to commit from the child component, but that will make this variant less reusable
      this.$store.commit("selectStoreFromResults", this.item_index);
      this.$emit("setStore", this.item_index);
    },
    goToNewTabLink(url) {
      this.$emit("goToNewTabLink", url);
    },
    showDetail(item) {
      this.$emit("showDetail", item);
    },
  },
};
</script>
<style>
.single-result-container .select-store-btn {
  background: #0992f1;
  padding: 10px 15px;
  font-size: 15px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  max-height: 50px;
  align-self: center;
}
.single-result-container .select-store-btn.active {
  background: #999;
}
.hours-information {
  text-align: center;
}
.p-address1, .p-address2 {
  text-transform:uppercase;
}
@media (max-width: 767px) {
  .single-result-container .select-store-btn {
    max-height: 75px;
  }
}
@media (max-width: 575px) {
  .hours-information {
    text-align: left;
  }
}
</style>
